import React from 'react';

import { Box } from '@mui/material';

type ValueRowProps = {
  columns: string;
  gap?: number;
  children: React.ReactNode;
};

export const ValueRow: React.FC<ValueRowProps> = ({
  columns,
  gap = 1,
  children,
}) => (
  <Box
    sx={{
      display: 'grid',
      alignItems: 'baseline',
      gridTemplateColumns: columns,
      gap: gap,
    }}
  >
    {children}
  </Box>
);
